<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.langMaps"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group" style="margin-top:40px;">
                <label class="col-sm-2 control-label"> Text </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="langMap[langItem.langCode]"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <div :ref="`editor${langItem.langCode}`"></div>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary"
                       v-if="
                        (checkPermission('school_contact_us_update') &&
                          $route.query.id) 
                      "
                     @click="checkEvent()"
                      >Save</el-button
                    >
                    <el-button @click="$router.go(-1)">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import E from 'wangeditor'
import i18next from 'i18next'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        langMaps: [],
      },
      'editoren_US':null,
      'editorzh_HK':null,
      'editorzh_CN':null,
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
    langMap() {
      return {
        en_US: "contactUs",
        zh_HK: "contactUsHk",
        zh_CN: "contactUsCn",
      };
    },
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    detailInfo: {
      handler: function () {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  created() {
    this.setObj();
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        content: "",
      });
    }
    this.detailInfo.langMaps = obj;


  },
  async mounted() {
    await this.init();
    this.detailInfo.langMaps.forEach(item=>{
      this.initEditor(item.langCode,item.content)
    })
  },
  methods: {
    
    setObj: function () {
      this.statusObj = [
        {
          value: 1,
          label: this.$i18n.t("message.Active"),
        },
        {
          value: 0,
          label: this.$i18n.t("message.Inactive"),
        },
      ];
    },
    async init() {
      var that = this;
      let obj = this.getAuthObj();
      obj.id = this.$route.query.id;
      obj.apiUrl = "/district/getContactUsInfo";
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (!data.data.result) {
        data.data.result = {};
      }
      if (!data.data.result.langMaps) {
        var obj2 = [];
        for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
          obj2.push({
            langCode: this.$store.state.userInfo.language[i].langCode,
            content:
              data.data.result[
                this.langMap[this.$store.state.userInfo.language[i].langCode]
              ] || "",
          });
        }
        data.data.result.langMaps = obj2;
      }

      // this.detailInfo = data.data.result
      this.$set(this, "detailInfo", data.data.result);

      setTimeout(function () {
        that.$store.state.edit = false;
      }, 500);
    },
    initEditor(lang,contant){
      const ele = this.$refs[`editor${lang}`]
      this[`editor${lang}`] = new E(ele)
      this[`editor${lang}`].config.lang = 'en'
      this[`editor${lang}`].i18next = i18next
      this[`editor${lang}`].config.menus = [
        'head',  // 标题
        'bold',  // 粗体
        'fontSize',  // 字号
        'fontName',  // 字体
        'italic',  // 斜体
        'underline',  // 下划线
        'strikeThrough',  // 删除线
        'foreColor',  // 文字颜色
        'backColor',  // 背景颜色
        'link',  // 插入链接
        'list',  // 列表
        'justify',  // 对齐方式
        'table',  // 表格
        'undo',  // 撤销
        'redo'  // 重复
        ]
      this[`editor${lang}`].config.colors = [
        '#000000',
        '#eeece0',
        '#1c487f',
        '#4d80bf',
        '#FFC007'
      ]
      this[`editor${lang}`].create()
      this[`editor${lang}`].txt.html(contant)
    },
    checkEvent: function () {
      const keyList = Object.keys(this.langMap);
      keyList.forEach((key) => {
        const content = this.detailInfo.langMaps.find((i) => {
          return i.langCode == key;
        });
        this.detailInfo[this.langMap[key]] = this[`editor${content.langCode}`].txt.html();
      });
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      let obj = this.getAuthObj();
      obj.contactUs = this.detailInfo.contactUs;
      obj.contactUsCn = this.detailInfo.contactUsCn;
      obj.contactUsHk = this.detailInfo.contactUsHk;
      obj.id = this.detailInfo.id;
      var data;
      obj.apiUrl = "/district/updateContactUsInfo";
      data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.state.edit = false;
        this.$message({
          message: "Save Success",
          type: "success",
        });
        this.init();
      }
    },
  },
};
</script>
